module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_eight@2x-f3ae38398030ed98be477aef860e2bf1.webp";